export const keepSidebarHandlerInPosition = ({ element }) => () => {
  element.style.setProperty("--windowInnerHeight", window.innerHeight + "px");

  window.addEventListener("resize", () => {
    element.style.setProperty("--windowInnerHeight", window.innerHeight + "px");
  });
};
